import React from 'react';

const LogoIcon = () => {
  return (
    <div>
      <img
        src="/small-logo.png"
        alt="Thales"
        style={{
          width: 'auto',
          height: 40,
        }}
      />
    </div>
  );
};

export default LogoIcon;
